<template>
  <div class="dzdh-container">
    <!-- 判断是否需要实名认证提示 -->
    <template v-if="dataSource.isLimit">
      <img :src="dataSource.value" alt="" />
      <LimitVideoTips
        :text="'内容'"
        style="position: absolute;bottom: 50%;left: 50%;transform: translate(-50%, -50%);"
      />
    </template>
    <template v-else>
      <img :src="dataSource.value" alt="" />
    </template>
  </div>
</template>

<script>
import LimitVideoTips from "@/views/wiki/tj/nikke/components/LimitVideoTips.vue";

export default {
  name: "dzdh-container",
  components: {
    LimitVideoTips
  },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.dzdh-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 476px;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
}
</style>
